import React, { useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { APP_CONFIG } from '@constants';
import { getObjectValue } from '@utility/utills';
import { LABEL } from '../../veriables';
import { logout } from '@reducers/oauth';
import styles from './index.module.scss';
import cn from 'classnames';
import Loader from '@components/common/Loader/newLoaderModal';

const CashOutConfirmation = (props) => {

  // Props Destructuring

  const {deviceInfo, userInfo, logout} = props;

  // State Management

  const [loader, setLoader] = useState(false);
  const response = props.location?.state?.response;

  // Methods

  const handleAmountBlur = (string) => {
    const element = document.querySelector(`#${string}`);
    element.blur();
  };

  const signOut = () => {
    const dataToSend = {
      latitude: '92',
      longitude: '92',
      deviceId: deviceInfo.deviceId,
      employeeId: getObjectValue(() => userInfo.externalId, null),
      employeeCard: getObjectValue(() => userInfo.employeeCard, null),
    };
    logout(dataToSend);
    props.history.replace(`${APP_CONFIG.BASE_URL}/checkIn?step=1`);
  };

  // HTML CSS Code

  return (
    <div className="col-12 h-100 w-100 text-primary od-text-primary">
      {loader && <Loader />}
      <div className="h-10 fs-24 d-flex align-items-center justify-content-center">
        {LABEL().CASHOUT_SUMMARY}
      </div>
      <div className={cn('w-100 row mx-0 justify-content-start align-items-end h-70')}>
        <div className="w-50 h-100 px-3">
          <div className="h-10 my-1 d-flex">
            <div className="w-50 py-2">{LABEL().BANK_AMOUNT}</div>
            <div className={cn(styles.input, 'w-50')}>
              <input
                id="bankAmount"
                type="number"
                onFocus={() => handleAmountBlur('bankAmount')}
                className="w-100 form-control p-1"
                value={Number(response?.bank).toFixed(2)}
                disabled
              />
            </div>
          </div>
          <div className="h-10 my-1 d-flex">
            <div className="w-50 py-2">{LABEL().PAID_IN_AMOUNT}</div>
            <div className={cn(styles.input, 'w-50')}>
              <input
                id="paidInAmount"
                type="number"
                onFocus={() => handleAmountBlur('paidInAmount')}
                className="w-100 form-control p-1"
                value={Number(response?.paidIn).toFixed(2)}
                disabled
              />
            </div>
          </div>
          <div className="h-10 my-1 d-flex">
            <div className="w-50 py-2">{LABEL().PAID_OUT_AMOUNT}</div>
            <div className={cn(styles.input, 'w-50')}>
              <input
                id="paidOutAmount"
                type="number"
                onFocus={() => handleAmountBlur('paidOutAmount')}
                className="w-100 form-control p-1"
                value={Number(response?.paidOut).toFixed(2)}
                disabled
              />
            </div>
          </div>
          <div className="h-10 my-1 d-flex">
            <div className="w-50 py-2">{LABEL().CASH_DROP_AMOUNT}</div>
            <div className={cn(styles.input, 'w-50')}>
              <input
                id="cashDropAmount"
                type="number"
                onFocus={() => handleAmountBlur('cashDropAmount')}
                className="w-100 form-control p-1"
                value={Number(response?.cashDrop).toFixed(2)}
                disabled
              />
            </div>
          </div>
          <div className="h-10 my-1 d-flex">
            <div className="w-50 py-2">{LABEL().CASH_PAYMENT_AMOUNT}</div>
            <div className={cn(styles.input, 'w-50')}>
              <input
                id="cashPaymentAmount"
                type="number"
                onFocus={() => handleAmountBlur('cashPaymentAmount')}
                className="w-100 form-control p-1"
                value={Number(response?.cashPayment).toFixed(2)}
                disabled
              />
            </div>
          </div>
          <div className="h-10 my-1 d-flex">
            <div className="w-50 py-2">{LABEL().CREDIT_CARD_PAYMENT_AMOUNT}</div>
            <div className={cn(styles.input, 'w-50')}>
              <input
                id="creditCardPaymentAmount"
                type="number"
                onFocus={() => handleAmountBlur('creditCardPaymentAmount')}
                className="w-100 form-control p-1"
                value={Number(response?.creditCardPayment).toFixed(2)}
                disabled
              />
            </div>
          </div>
          <div className="h-10 my-1 d-flex">
            <div className="w-50 py-2">{LABEL().CREDIT_CARD_TIP_AMOUNT}</div>
            <div className={cn(styles.input, 'w-50')}>
              <input
                id="creditCardTipAmount"
                type="number"
                onFocus={() => handleAmountBlur('creditCardTipAmount')}
                className="w-100 form-control p-1"
                value={Number(response?.creditCardTip).toFixed(2)}
                disabled
              />
            </div>
          </div>
          <div className="h-10 my-1 d-flex">
            <div className="w-50 py-2">{LABEL().PENDING_CASHOUT_AMOUNT}</div>
            <div className={cn(styles.input, 'w-50')}>
              <input
                id="pendingCashoutAmount"
                type="number"
                onFocus={() => handleAmountBlur('pendingCashoutAmount')}
                className="w-100 form-control p-1"
                value={Number(response?.pendingCashOut).toFixed(2)}
                disabled
              />
            </div>
          </div>
          <div className="h-10 my-1 d-flex">
            <div className="w-50 py-2">{LABEL().OVER_SHORT_AMOUNT}</div>
            <div className={cn(styles.input, 'w-50')}>
              <input
                id="overShortAmount"
                type="number"
                onFocus={() => handleAmountBlur('overShortAmount')}
                className="w-100 form-control p-1"
                value={Number(response?.overShort).toFixed(2)}
                disabled
              />
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 p-0 h-20 row mx-0 justify-content-center align-items-end py-2">
        <div className="col-6 text-center">
          <button
            type="button"
            disabled
            className="btn70 roundedLg od-btn-primary btn-primary btn-ripple my-1 w-50"
            onClick={() => signOut()}
          >
            <div className="fs-18">{LABEL().PRINT}</div>

          </button>
        </div>
        <div className="col-6 text-center">
          <button
            type="button"
            className="btn70 roundedLg od-btn-primary btn-primary btn-ripple my-1 w-50"
            onClick={() => { setLoader(true); signOut(); }}
          >
            <div className="fs-18">{LABEL().DONE}</div>

          </button>
        </div>
      </div>
    </div>
  );
};

// Redux Part

const mapStateToProps = ({
  oauth
}) => ({
  userInfo: oauth.loggedInUserData,
  auth: oauth.authInfo,
  deviceInfo: oauth.deviceInformation,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  logout
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CashOutConfirmation);
